import Big from 'big.js';

export function calcPositionBetween(bigStart, bigEnd) {
  const divisor = 2 + Math.random();
  return bigEnd.minus(bigStart).div(divisor).plus(bigStart);
}

/** Cap stored fractional positions so repeated midpoints stay bounded. */
export const POSITION_MAX_LENGTH = 16;

export function truncatePosition(value, maxLength = POSITION_MAX_LENGTH) {
  let s = String(value ?? '');
  if (s.length <= maxLength) {
    return s;
  }
  s = s.slice(0, maxLength);
  if (s.endsWith('.')) {
    s = s.slice(0, -1);
  }
  return s;
}

/**
 * Fractional index string strictly between start and end (default 0–1).
 */
export function positionBetween(
  start = 0,
  end = 1,
  maxLength = POSITION_MAX_LENGTH
) {
  const bigStart = Big(start ?? 0);
  const bigEnd = Big(end ?? 1);
  return truncatePosition(
    calcPositionBetween(bigStart, bigEnd).toString(),
    maxLength
  );
}
